// extracted by mini-css-extract-plugin
module.exports = {"redBackgroundColor":"style_redBackgroundColor__4Jcer","yellowBackgroundColor":"style_yellowBackgroundColor__1Tz6h"};